//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passTranslucent = 8.0;\n\
";
